// extracted by mini-css-extract-plugin
module.exports = {"internalContainer":"SpinnerContainer_internalContainer__kt2ni","spinner":"SpinnerContainer_spinner__kzDgO"};